module.exports = __webpack_public_path__ + "static/media/mastercard.2bad7d6f.png";